import { ArrowUpRight, Linkedin } from 'lucide-react'
import { contactInfo } from '@/data/about'

const CHANNELS = [
  { heading: 'General', email: contactInfo.email },
  { heading: 'Sales', email: contactInfo.sales },
  { heading: 'Support', email: contactInfo.support },
  { heading: 'Press', email: contactInfo.press },
]

/** Contact row in the strip grammar (.25fr label / 1fr content). */
export function ContactStrip() {
  return (
    <section aria-labelledby="contact-title" className="landing-section-sm border-t border-[var(--color-landing-gray-200)] dark:border-[var(--color-landing-gray-800)]">
      <div className="landing-container grid gap-8 lg:grid-cols-[minmax(0,0.25fr)_minmax(0,1fr)] lg:gap-12">
        <div>
          <h2 id="contact-title" className="font-[family-name:var(--font-landing-display)] text-[1.6rem] uppercase leading-[1.4] tracking-[-0.02em] text-[var(--color-landing-gray-900)] dark:text-white">
            Get in touch
          </h2>
          <p className="mt-2 text-[color-mix(in_srgb,var(--color-landing-gray-900)_66%,transparent)] dark:text-[color-mix(in_srgb,white_62%,transparent)]">
            We'd love to hear from you
          </p>
        </div>

        <div>
          <div className="grid gap-x-8 gap-y-6 sm:grid-cols-2 xl:grid-cols-4">
            {CHANNELS.map((channel) => (
              <a
                key={channel.heading}
                href={`mailto:${channel.email}`}
                className="group block border-t border-[var(--color-landing-gray-300)] pt-4 dark:border-[var(--color-landing-gray-700)]"
              >
                <h3 className="text-sm font-semibold uppercase tracking-wide text-[color-mix(in_srgb,var(--color-landing-gray-900)_66%,transparent)] dark:text-[color-mix(in_srgb,white_62%,transparent)]">
                  {channel.heading}
                </h3>
                <span className="mt-1 block text-base font-semibold [overflow-wrap:anywhere] md:text-[1.0625rem] text-[var(--color-landing-gray-900)] transition-colors duration-200 group-hover:text-[var(--color-landing-accent)] dark:text-white dark:group-hover:text-white/70">
                  {channel.email}
                </span>
              </a>
            ))}
          </div>
          <a
            href={contactInfo.social.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
            className="group mt-8 inline-flex items-center gap-2 text-[var(--color-landing-gray-900)] transition-colors duration-200 hover:text-[var(--color-landing-accent)] dark:text-white"
          >
            <Linkedin aria-hidden className="h-5 w-5" />
            <span className="text-sm font-semibold uppercase tracking-wide">LinkedIn</span>
            <ArrowUpRight aria-hidden className="h-4 w-4 transition-transform duration-200 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </a>
        </div>
      </div>
    </section>
  )
}
